import { Box, Flex, Radio, RadioGroup } from '@amzn/ring-ui-react-components';
import { Icon } from 'src/shared/components/Icon';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from 'src/shared/components/Modal';
import { Location } from '../LocationSelectorDropdown';

export interface LocationSelectorModalProps extends ModalProps {
  locations: Array<Location>;
  onChange: (args: string) => void;
  selectedLocation: string;
}

export const LocationSelectorModal = ({
  locations,
  onChange,
  selectedLocation,
  ...props
}: LocationSelectorModalProps) => {
  if (locations.length < 2) return null;

  return (
    <Modal {...props} isCentered>
      <ModalOverlay>
        <ModalContent p={0}>
          <ModalHeader justifyContent="center">
            <Box color="neutral.500" textStyle="body-normal-medium">
              Change Location
            </Box>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody px={0} py={7}>
            <Box ml={7} mb={5} width={10} height={6}>
              <Icon name="marker" color="primary.500" size={40} />
            </Box>
            <Box
              ml={7}
              mb={2}
              color="neutral.500"
              textStyle="heading-normal-medium"
            >
              Change Location
            </Box>
            <Box ml={7} mb={7} textStyle="body-large-light">
              Choose the location you would like to see to review and select
              your videos.
            </Box>
            <Box
              ml={7}
              mb={2}
              color="neutral.300"
              textStyle="body-normal-medium"
            >
              Your Available Locations
            </Box>
            <Box>
              <RadioGroup value={selectedLocation} onChange={onChange}>
                {locations?.map((location) => (
                  <Box
                    key={location.id}
                    borderTopColor="tertiary.500"
                    borderTopStyle="solid"
                    borderTopWidth={1}
                    borderBottomColor="tertiary.500"
                    borderBottomStyle="solid"
                    borderBottomWidth={1}
                    bg="primary.100"
                  >
                    <Flex flexDirection="row" ml={7} py={4}>
                      <Radio value={location.id} size="lg" mr={4} />
                      <Icon
                        name="camera"
                        color="primary.500"
                        size={20}
                        mr={4}
                        pt={1}
                      />
                      <Box color="neutral.500" textStyle="body-normal-medium">
                        {location.name}
                      </Box>
                    </Flex>
                  </Box>
                ))}
              </RadioGroup>
            </Box>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
};
